export default {"src":"/_next/static/media/gn-games-icon.2040a72f.svg","height":40,"width":85,"blurWidth":0,"blurHeight":0};